var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(_vm.isPageReady && _vm.currentDataId)?[_c('who-are-you',{attrs:{"id":_vm.currentDataId},on:{"show-logged-user-profile":function($event){_vm.currentDataId = _vm.loggedUser.id_person}}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }